import { HttpError } from '@littlebird/auth-client';

export type OtpErrorVerdict = {
  /** True iff the response specifically indicates a wrong OTP. */
  isInvalidCode: boolean;
  /** Backend-provided user-facing message when present. */
  userMessage?: string;
};

/**
 * Classify an OTP verify error.
 *
 * - Auth0 passwordless verify returns HTTP 403 + body.error === 'invalid_grant'
 *   for a wrong/expired/already-used code (rate limits / blocks land on 429,
 *   not here, so they don't trigger the typo recovery UX).
 * - Backend FastAPI returns HTTP 400 with detail.user_error_message starting
 *   with "Invalid OTP" for a wrong code (429/404/5xx are different recovery
 *   paths and must not be treated as a typo).
 */
export function classifyOtpError(error: unknown): OtpErrorVerdict {
  if (!(error instanceof HttpError)) {
    return { isInvalidCode: false };
  }
  const userMessage =
    typeof error.body?.detail?.user_error_message === 'string'
      ? (error.body.detail.user_error_message as string)
      : undefined;

  if (error.status === 403 && error.body?.error === 'invalid_grant') {
    return { isInvalidCode: true, userMessage };
  }
  if (
    error.status === 400 &&
    userMessage &&
    userMessage.startsWith('Invalid OTP')
  ) {
    return { isInvalidCode: true, userMessage };
  }
  return { isInvalidCode: false, userMessage };
}
